import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  padding-bottom: 40px;

  .header-info {
      display: flex;
      align-items: center;
      gap: 20px;
      margin-bottom: 30px;
      background: #f9f9f9;
      padding: 20px;
      border-radius: 15px;
      border: 1px solid #eee;

      img {
          width: 80px;
          height: 80px;
          border-radius: 40px;
          object-fit: cover;
          border: 3px solid #008037;
      }

      .name-info {
          h2 { margin: 0; font-size: 24px; color: #333; }
          p { margin: 2px 0 0 0; color: #666; }
      }
  }

  .dashboard-header {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      margin-bottom: 30px;
      flex-wrap: wrap;
      gap: 20px;
  }

  h1 {
      font-size: 24px;
      margin: 0;
      color: #1a1a1a;
  }

  .section-title {
      font-size: 18px;
      font-weight: 600;
      color: #333;
      margin: 30px 0 15px 0;
      display: flex;
      align-items: center;
      gap: 10px;
      
      &::after {
          content: '';
          flex: 1;
          height: 1px;
          background: #f0f0f0;
      }
  }

  /* Tags/Cards informativos principais */
  .main-tags {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
      gap: 15px;
      margin-bottom: 30px;
  }

  .tag-item {
      padding: 20px 25px;
      border-radius: 15px;
      display: flex;
      flex-direction: column;
      gap: 5px;
      background: #fff;
      color: #333;
      font-weight: 600;
      box-shadow: 0 4px 12px rgba(0,0,0,0.05);
      border: 1px solid #f0f0f0;
      
      .tag-header {
          display: flex;
          align-items: center;
          gap: 10px;
          font-size: 14px;
          color: #666;
          font-weight: 500;
      }
      
      .value {
          font-size: 26px;
          color: #1a1a1a;
          font-weight: 800;
          margin-top: 5px;
      }

      &.highlight {
          border-left: 4px solid #008037;
          .value { color: #008037; }
      }
      
      &.warning {
          border-left: 4px solid #f2760a;
          .value { color: #f2760a; }
      }
  }

  /* Grid de Status dos Leads */
  .status-grid {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
      gap: 15px;
      margin-bottom: 30px;
  }

  .status-tag {
      background: #fff;
      padding: 15px 20px;
      border-radius: 12px;
      border: 1px solid #f0f0f0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      transition: all 0.2s;
      cursor: pointer;
      
      &:hover {
          border-color: #008037;
          transform: translateY(-2px);
          box-shadow: 0 4px 8px rgba(0,0,0,0.08);
      }

      .label {
          color: #666;
          font-size: 14px;
          font-weight: 500;
      }

      .count {
          font-size: 22px;
          font-weight: 800;
          color: #008037;
      }
  }

  .main-stats {
      display: grid;
      grid-template-columns: 1.5fr 1fr;
      gap: 25px;
      margin-top: 30px;
      @media (max-width: 1000px) {
          grid-template-columns: 1fr;
      }
  }

  .chart-container {
      background: #fff;
      padding: 25px;
      border-radius: 15px;
      box-shadow: 0 4px 12px rgba(0,0,0,0.05);
      border: 1px solid #eee;
      
      h3 {
          margin-bottom: 20px;
          color: #333;
          font-size: 16px;
      }
  }

  .metrics-box {
      background: #fff;
      padding: 25px;
      border-radius: 15px;
      box-shadow: 0 4px 12px rgba(0,0,0,0.05);
      border: 1px solid #eee;
      
      .metric-item {
          margin-bottom: 20px;
          &:last-child { margin-bottom: 0; }
          
          .metric-header {
              display: flex;
              justify-content: space-between;
              margin-bottom: 8px;
              font-weight: 500;
              font-size: 14px;
              color: #444;
          }
      }
  }

  .conversion-box {
      margin-top: 20px;
      background: #f8faf9;
      padding: 20px;
      border-radius: 12px;
      display: flex;
      align-items: center;
      gap: 20px;

      .percentage {
          font-size: 36px;
          font-weight: 800;
          color: #008037;
      }
      
      .label {
          h4 { margin: 0; font-size: 16px; color: #333; }
          p { margin: 2px 0 0 0; color: #777; font-size: 12px; }
      }
  }

  .filters {
      display: flex;
      gap: 15px;
      flex-wrap: wrap;
      align-items: flex-end;
      margin-bottom: 20px;
      background: #fff;
      padding: 20px;
      border-radius: 15px;
      box-shadow: 0 2px 8px rgba(0,0,0,0.05);
      border: 1px solid #f0f0f0;
  }
`;
